//
//
//
//
//
//
//

import Appbar from '@/components/core/Appbar.vue';

export default {
	components: {
		Appbar,
	},
	head: {
		title: 'Calculadora de Viajes Fin de Curso',
		meta: [
			{
				hid: 'description',
				name: 'description',
				content:
					'Personaliza tu Viaje de Estudiantes. Usa la mejor herramienta para calcular el precio de tu Viaje Fin de Curso de forma exacta y personalizada.',
			},
		],
	},
};
